export const activitiesSelector = (state) => state.Activities.entities;

export const activitiesValueSelector = (state) =>
  Object.values(activitiesSelector(state));
